export default {
  timeOut: 60000,
  codeKeys: ['code', 'returnCode'],
  messageKeys: ['msg', 'returnMsg'],
  successCodes: [200, '200', '00000'],
  tokenExpiredCodes: [10006, 10007, 40003, '010006', '010007', '040003'],
  customParams: ['resultKey', 'disableHandle', 'disableToken', 'disableToast','disableRefreshToken'],
  tokenExpiredMessage: {
    title: '登陆过期',
    content: '登陆过期，请重新登录',
    confirm: '重新登录',
    cancel: '取消'
  },
  defaultErrorMessage: '请求失败',
  statusErrorMessage: [{
    code: 400,
    msg: '请求失败'
  }, {
    code: 403,
    msg: '拒绝访问'
  }, {
    code: 404,
    msg: '请求地址错误'
  }, {
    code: 408,
    msg: '请求超时'
  }, {
    code: 500,
    msg: '服务器内部错误'
  }, {
    code: 501,
    msg: '服务未实现'
  }, {
    code: 502,
    msg: '网关错误'
  }, {
    code: 503,
    msg: '服务不可用'
  }, {
    code: 504,
    msg: '网关超时'
  }, {
    code: 505,
    msg: 'HTTP版本不受支持'
  }]
}
